// ==============================|| OVERRIDES - SELECT ||============================== //

export default function Select(theme) {
  return {
    MuiSelect: {
      styleOverrides: {
        select: {
          '&:focus': {
            backgroundColor: theme.palette.grey[200]
          }
        },
        selectOpen: {
          backgroundColor: 'white'
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: 'white !important',
          '& .MuiMenuItem-root': {
            backgroundColor: 'white !important'
          }
        },
        list: {
          backgroundColor: 'white !important'
        }
      }
    }
  };
}

